import { render, staticRenderFns } from "./navbarBig.vue?vue&type=template&id=41d53036&scoped=true&"
import script from "./navbarBig.vue?vue&type=script&lang=js&"
export * from "./navbarBig.vue?vue&type=script&lang=js&"
import style0 from "./navbarBig.vue?vue&type=style&index=0&id=41d53036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d53036",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
